import { app } from '../../../../../../app';
import { Controller } from './export-accounts.controller';

app.component('companyUserDirectoriesManageGroupAccountsExport', {
    bindings: {
        accounts: '<',
        currentCompany: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./export-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/export/export-accounts.component.js